<s1-input-select [control]="control" [itemsList]="tipi" [label]="'negozi.fields.tipo'" [readonly]="readonly"></s1-input-select>